export default {
  text: '#263238',
  faded: '#8a9094',
  primary: '#5bb7db',
  danger: '#D94238',
  warning: '#d93025',
  success: '#34C759',
  border: '#aaaaaa',
  white: '#ffffff',
  grey: '#8C8C8B',
  black: '#000000',
  blue: '#1a5fa8',
  lightOrange: '#F15725',
  blackfilterItems: '#808080',
  disabled: 'rgb(238, 237, 237)'
};
